/*
  作者：bai.zhiming
  时间：2017-03-03
  描述：采编中心-app渠道新闻稿编辑器服务工厂
*/
'use strict';
angular.module('ueditorForAppServiceModule', ['insertComponentModule', 'uploadPicturesModule', 'appUeditorPreviewModule', 'cloudPlateModule', 'insertLeaderModule', 'insertTopicModule', 'insetEchartsModule']).factory('ueditorForAppService', ['$modal', '$stateParams', '$q', 'trsHttpService', 'editIsLock', function($modal, $stateParams, $q, trsHttpService, editIsLock) {
    return {

        /**
         * [insertComponent description] 插入组件
         * @param {ue} [varname] [description] 编辑器实例
         * @return {[obj]}   toolBar   [description]
         */
        insertComponent: function(ue) {
            var modalInstance = $modal.open({
                templateUrl: './components/util/ueditor/service/insertComponent/insertComponent_tpl.html',
                windowClass: 'insert-component-window',
                backdrop: false,
                controller: 'insertComponentCtrl',
                resolve: {
                    ue: function() {
                        return ue;

                    }
                }
            });
            modalInstance.result.then(function(result) {});
        },
        
        /**
         * [insertLeaderLink 多图上传]
         * @return {[type]} [description]
         */
        uploadPic: function() {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: './components/util/ueditor/service/uploadPictures/uploadPictures_tpl.html',
                windowClass: 'app-upload-pictures-window',
                backdrop: false,
                controller: 'uploadPicturesCtrl',
                resolve: {
                    params: function() {
                        return '';
                    }
                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        },

        /**
         * [insertLeaderLink 多图上传]
         * @param {[FN]} [save] [description] 预览前的保存
         * @return {[type]} [description]
         */
        preview: function(save) {
            save().then(function() {
                var params = {
                    serviceid: 'mlf_metadatacenter',
                    methodname: 'preview',
                    objectId: $stateParams.appchnldocid
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    editIsLock.lockDraft($stateParams.metadataid);
                    $modal.open({
                        templateUrl: './components/util/ueditor/service/appUeditorPreview/preview_tpl.html',
                        windowClass: 'app-ueditor-preview-window',
                        backdrop: true,
                        controller: 'appUeditorPreviewCtrl',
                        resolve: {
                            previewUrl: function() {
                                return data.URLS[0];
                            }
                        }
                    });
                });
            });
        },

        /**
         * [dragAndDrop description] 自定义标签拖拽功能
         * @param   {[type]}  ue           [ue description] 编辑器实例
         * @param   {[type]}  DragtagName  [DragtagName description] 需要拖拽的自定义标签名称
         * @param   {[type]}  moveTimeout  [moveTimeout description] 定时器变量
         * @return  {function}             [return description]
         */
        dragAndDrop: function(ue, DragtagName, moveTimeout) {
            $(ue.body).unbind('mouseleave').bind('mouseleave', function() {
                $(this).find('.dragTo').removeClass('dragTo');
                $(this).find('.dragToFirst').removeClass('dragToFirst');
            });
            $(ue.body).find(DragtagName).unbind('mouseover').unbind('mouseleave');
            $(ue.body).find(DragtagName).bind('mouseover', function() {
                $(this).remove('.dragmove').append("<div draggable='true' contenteditable='false' class='dragmove'></div>");
                var dragDiv = $(this).find("div[class='dragmove']");
                // dragDiv.css(moveCss);
                dragDiv.bind('mouseover', function() {
                    clearTimeout(moveTimeout);
                });
                dragDiv.bind('mousedown', function(event) {
                    var self = this;
                    var targetElement;
                    $(ue.body).unbind('drop').bind('drop', function(ev) {
                        try {
                            if (ev.originalEvent.clientY <= 32 && ev.target.tagName === 'BODY') {
                                ue.body.insertBefore(self.parentElement, ue.body.firstChild);
                            }
                            if ((ev.target.tagName === 'BODY' && ev.originalEvent.clientY > 32) || ev.target.tagName !== 'BODY') {
                                insertAfter(self.parentElement, targetElement);
                            }
                            ue.fireEvent('contentchange');
                        } catch (e) {
                            // 
                        } finally {
                            $(ue.body).find('.dragTo').removeClass('dragTo');
                            $(ue.body).find('.dragToFirst').removeClass('dragToFirst');
                        }
                    }).unbind('dragover').bind('dragover', function(ev) {
                        var target = ev.target;
                        var tagName = target.tagName;
                        if (tagName === 'P' && tagName === 'BLOCKQUOTE') {
                            if (tagName !== 'BODY') {
                                $(ue.body).find('.dragTo').removeClass('dragTo');
                                $(ue.body).find('.dragToFirst').removeClass('dragToFirst');
                                $(ev.target).addClass('dragTo');
                                targetElement = target;
                            }
                        }
                        if (tagName === 'BODY' && ev.originalEvent.clientY <= 32) {
                            $(ue.body).find('.dragToFirst').removeClass('dragToFirst');
                            $(ue.body).find('.dragTo').removeClass('dragTo');
                            $(ue.body).children().eq(0).addClass('dragToFirst');
                        }
                        ev.originalEvent.preventDefault();
                    });
                });
                dragDiv.bind('mouseup', function() {
                    setTimeout(function() {
                        $(ue.body).find('.dragTo').removeClass('dragTo');
                        $(ue.body).find('.dragToFirst').removeClass('dragToFirst');
                    }, 50);
                });
            });
            $(ue.body).find(DragtagName).bind('mouseleave', function() {
                var self = this;
                moveTimeout = setTimeout(function() {
                    $(self).find("div[class='dragmove']").remove();
                }, 50);
            });

            /**
             * [insertAfter description]
             * @param   {[type]}  newElement     [newElement description]
             * @param   {[type]}  targetElement  [targetElement description]
             * @return  {[type]}                 [return description]
             */
            function insertAfter(newElement, targetElement) {
                var parent = targetElement.parentNode;
                if (parent.lastChild == targetElement) {
                    parent.appendChild(newElement);
                } else {
                    parent.insertBefore(newElement, targetElement.nextSibling);
                }
            }
        },

        /**
         * [componentEnter 组件中的回车事件]
         * @param {[object]} [ue] [description] 编辑器实例
         * @param {[object]} [scope] [description] 指令控制域scope
         * @return {[type]} [description]
         */
        componentEnter: function(ue, scope) {
            ue.ready(function() {
                $(ue.body).keydown(function(evt) {
                    var rng = ue.selection.getRange();
                    // 上传图片组件中，选中图片禁止回车 start
                    var TagFlg = (rng.startContainer.tagName === 'P' && rng.endContainer.tagName === 'P');
                    var classFlg = (rng.startContainer.className === 'wgImage-source' && rng.endContainer.className === 'wgImage-source');
                    if (evt.keyCode === 13 && TagFlg && classFlg) {return false;}
                    // 上传图片组件中，选中图片禁止回车 end
                    // 处理自定组件中，回车新建组件bug start
                    if (evt.keyCode === 13 && scope.insertDisable) {
                        var br = document.createElement('br');
                        rng.insertNode(br).setStartAfter(br).setCursor();
                        ue.fireEvent('contentChange');
                        return false;
                    }
                });
            });
        },

        /**
         * [supplementaryBlank 组件之后自动补充空行]
         * @param {[object]} [ue] [description] 编辑器实例
         * @return {[type]} [description]
         */
        supplementaryBlank: function(ue) {
            ue.ready(function() {
                $(ue.body).keydown(function(evt) {
                    var rng = ue.selection.getRange();
                    // 自定义组件之后，自动补充行，可以继续编辑 start
                    var isInLead = (rng.startContainer.parentElement.tagName === 'BLOCKQUOTE' && rng.endContainer.parentElement.tagName === 'BLOCKQUOTE'); // 是否在导语内部
                    var isInPicture = rng.startContainer.parentElement.tagName === 'P' &&
                        rng.startContainer.parentElement.className === 'wgImage-content' &&
                        rng.endContainer.parentElement.tagName === 'P' &&
                        rng.endContainer.parentElement.className === 'wgImage-content';
                    if (rng.startContainer.parentNode.tagName !== 'BODY') { // 处理组件外回删时无法光标定位问题
                        if (isInLead && rng.endContainer.parentNode.nextElementSibling === null) { // 如果是导语，判断父标签的下一个兄弟子节点是否存在
                            supplementaryLabel();
                        }
                        if (isInPicture && rng.endContainer.parentNode.parentNode.nextElementSibling === null) { // 如果是图片，判断父标签的父标签的下一个兄弟子节点是否存在
                            supplementaryLabel();
                        }
                    }
                    // 自定义组件之后，自动补充行，可以继续编辑 end
                });

            });

            /**
             * [supplementaryLabel description]补充空标签
             * @return  {[type]}  [return description]
             */
            function supplementaryLabel() {
                var p = document.createElement('p');
                p.innerHTML = '<br/>';
                ue.body.append(p);
                ue.fireEvent('contentChange');
            }
            ue.addListener('keydown', function(cmd, evt) { // 处理组件外回删时无法光标定位问题
                if (evt.keyCode === 8) {
                    setTimeout(function() {
                        if (ue.body.lastElementChild.tagName !== 'P') {
                            var p = document.createElement('p');
                            p.innerHTML = '<br/>';
                            ue.body.append(p);
                            ue.fireEvent('contentChange');
                        }
                    }, 500);
                }
            });
        },

        /**
         * [deleteComponent 删除组件]
         * @param {[object]} [ue] [description] 编辑器实例
         * @return {[type]} [description]
         */
        deleteComponent: function(ue) {
            ue.ready(function() {
                $(ue.body).keydown(function(evt) {
                    var rng = ue.selection.getRange();
                    var isCollapsed = rng.collapsed; // 是否是闭合选区
                    var parentNode = rng.startContainer.parentNode.tagName === 'BODY' ? rng.startContainer : rng.startContainer.parentNode; // 光标所在父节点
                    if (!parentNode) {return;}
                    var positionIndex = rng.startOffset;
                    var rngTagName = parentNode.tagName; // 光标所在区域父节点名称
                    if (typeof parentNode.innerText !== 'string') {return;}
                    var isEmpty = (parentNode.innerText.replace(/\n/g, '').replace(/\u200b/g, '') === '');
                    var previousSibling = parentNode.previousSibling; // 光标所在的父节点的前一个节点
                    if (evt.keyCode !== 8 || !isCollapsed) {return;}
                    if (!previousSibling) {return;}
                    if (previousSibling.tagName !== 'BLOCKQUOTE') {return;}
                    if (rngTagName !== 'BODY' && rngTagName !== 'BLOCKQUOTE' && parentNode.className !== 'wgImage-content' && (isEmpty || positionIndex === 0)) {
                        rng.selectNode(previousSibling);
                        rng.deleteContents();
                        ue.fireEvent('contentChange');
                        return false;
                    }
                });
            });
        },

        /**
         * [componentDelete 图片组件中，选中图片后按删除按键，直接删除整个组件]
         * @param {[object]} [ue] [description] 编辑器实例
         * @return {[type]} [description]
         */
        componentDelete: function(ue) {
            ue.ready(function() {
                $(ue.body).keydown(function(evt) {
                    var rng = ue.selection.getRange();
                    var sTagName = rng.startContainer.tagName;
                    var sClassName = rng.startContainer.className;
                    var eTagName = rng.endContainer.tagName;
                    var eClassName = rng.endContainer.className;
                    var positionDifference = rng.endOffset - rng.startOffset;
                    if (evt.keyCode === 8 && (sTagName === 'P' && eTagName === 'P') && (sClassName === 'wgImage-source' && eClassName === 'wgImage-source') && positionDifference === 1) {
                        rng.selectNode(rng.startContainer.parentElement);
                        rng.deleteContents();
                        ue.fireEvent('contentChange');
                        return false;
                    }
                });
            });
        },

        /**
         * [cloudPlate description] 云平台组件
         * @return {[type]}    [description]
         */
        cloudPlate: function() {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: './components/util/ueditor/service/cloudPlate/cloudPlate_tpl.html',
                windowClass: 'cloud-plate-window',
                backdrop: false,
                controller: 'cloudPlateCtrl'
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        },

        /**
         * [insertLeader description] 插入官员
         * @param  {[type]} siteId [description] 站点id
         * @return {[type]}        [description]
         */
        insertLeader(siteId) {
            let deffer = $q.defer();
            let modalInstance = $modal.open({
                templateUrl: './components/util/ueditor/service/insertLeader/insertLeader_tpl.html',
                windowClass: 'insert_leader',
                backdrop: false,
                controller: 'insertLeaderCtrl',
                resolve: {
                    siteId() {
                        return siteId;
                    }
                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        },

        /**
         * [insertTopic description] 插入话题
         * @param  {[type]} siteId [description] 站点id
         * @return {[type]}        [description]
         */
        insertTopic(siteId) {
            let deffer = $q.defer();
            let modalInstance = $modal.open({
                templateUrl: './components/util/ueditor/service/insertTopic/insertTopic_tpl.html',
                windowClass: 'insert_topic',
                backdrop: false,
                controller: 'insertTopicCtrl',
                resolve: {
                    siteId() {
                        return siteId;
                    }
                }
            });
            modalInstance.result.then(function(result) {
                deffer.resolve(result);
            });
            return deffer.promise;
        },

        /**
         * [insertEcharts 插入图表] 插入echarts
         * @return {[type]} [description]
         */
        insertEcharts() {
            var deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: './components/util/ueditor/service/insertEcharts/insertEcharts_tpl.html',
                windowClass: 'insert-echarts-windows',
                backdrop: false,
                controller: 'insetEchartsCtrl'
            });
            modalInstance.result.then(function(url) {
                // 这里是返回的是张图片 这张图片插入到编辑器里就可以
                var html = '<p style="display:inline-block;width:100%;text-align:center;">' +
                '<img width="640" src="' + url + '" />' + // 跟产品确认 插入的图片宽度为640 高度自适应
                '</p>';
                deffer.resolve(html);
            });
            return deffer.promise;
        }
    };
}]);
